/************
 * Developed by : Shiva Software Solutions
 * Date : 11-05-2023
 * Descriptions : Route page for report page
 * Dependicies : To use @material-ui/core,react-router-dom,formik
 ************/
import React from 'react';
import {authRole} from '../../shared/constants/AppConst';

export const reportpageConfigs = [
  {
    auth: authRole.admins,
    routes: [
      {
        path: '/reports',
        component: React.lazy(() => import('./simpleTabs')),
      },
    ],
  },
];
